import { TheWestSection } from '@news-mono/common'
import { isCorporateAccount, metrics } from '@news-mono/component-library'
import { StaticRoute, StaticRoutes } from '@news-mono/web-common'
import { layout } from '../../App.routing'
import { createUnsubscribePage } from './unsubscribe'

const createEmailPreferencePage: StaticRoute<TheWestSection> = ({ store }) => {
    const { subscriptionType } = store.getState().authentication
    if (isCorporateAccount(subscriptionType)) return null

    return {
        kind: 'page',
        heading: 'Email Preferences',
        hideHeading: true,
        pageType: 'static',
        adTargeting: {
            pageId: 'email-preferences',
            adUnitPath: '',
            ssAdUnits: [],
            topics: [],
        },
        section: 'default',
        compositions: [
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    verticalGutters: true,
                    horizontalGutters: false,
                },
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'thor',
                            props: {
                                containerWidth: '100%',
                                horizontalGutters: true,
                                hasBackgroundFill: true,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'email-preference',
                                        props: {},
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            }),
        ],
    }
}

const createUnsubscribeAllPage: StaticRoute<TheWestSection> = ({ store }) => {
    const { subscriptionType } = store.getState().authentication
    if (isCorporateAccount(subscriptionType)) return null
    return {
        kind: 'page',
        heading: 'Email Preferences Unsubscribe All',
        hideHeading: true,
        pageType: 'static',
        adTargeting: {
            pageId: 'email-preferences-unsubscribe-all',
            adUnitPath: '',
            ssAdUnits: [],
            topics: [],
        },
        section: 'default',
        compositions: [
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    verticalGutters: true,
                    horizontalGutters: false,
                },
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'thor',
                            props: {
                                containerWidth: '100%',
                                horizontalGutters: false,
                                hasBackgroundFill: false,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'email-preferences-unsubscribe-all',
                                        props: {},
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            }),
        ],
    }
}

export const getEmailPreferenceRouteInfo: StaticRoutes<TheWestSection> = {
    '/manage-email-preferences': createEmailPreferencePage,
    '/manage-email-preferences/unsubscribe': createUnsubscribePage,
    '/manage-email-preferences/unsubscribe/all': createUnsubscribeAllPage,
}
